import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <span ref={ref} className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "110%" }}
        animate={inView ? { y: 0 } : {}}
        transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const ChapterHeading = ({ number, overline, title, dark = false }) => (
  <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12">
    <Reveal className="md:col-span-3">
      <div className="md:sticky md:top-32 flex md:flex-col items-baseline md:items-start gap-4">
        <span className={`font-serif text-5xl md:text-6xl font-light ${dark ? "text-ivory/40" : "text-teal/30"}`} data-testid={`chapter-number-${number}`}>
          {number}
        </span>
        <span className={`text-xs tracking-[0.25em] uppercase font-semibold ${dark ? "text-ivory/70" : "text-teal"}`}>
          {overline}
        </span>
      </div>
    </Reveal>
    <div className="md:col-span-9">
      <MaskLine>
        <h2 className={`font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-tight text-balance ${dark ? "text-ivory" : "text-charcoal"}`}>
          {title}
        </h2>
      </MaskLine>
    </div>
  </div>
);
